"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRoot = exports.StyledInputOverrideRoot = exports.StyledInputOverrideInput = void 0;
var _styles = require("../styles");
var _input = require("../input");
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

const StyledRoot = exports.StyledRoot = (0, _styles.styled)('div', {
  display: 'flex',
  alignItems: 'center'
});
StyledRoot.displayName = "StyledRoot";
StyledRoot.displayName = 'StyledRoot';
const StyledInputOverrideRoot = exports.StyledInputOverrideRoot = (0, _styles.withStyle)(_input.StyledRoot, ({
  $size = _input.SIZE.default
}) => {
  const width = {
    [_input.SIZE.mini]: '32px',
    [_input.SIZE.compact]: '36px',
    [_input.SIZE.default]: '48px',
    [_input.SIZE.large]: '56px'
  }[$size];
  return {
    width,
    marginRight: '8px'
  };
});
StyledInputOverrideRoot.displayName = "StyledInputOverrideRoot";
StyledInputOverrideRoot.displayName = 'StyledInputOverrideRoot';
const StyledInputOverrideInput = exports.StyledInputOverrideInput = (0, _styles.withStyle)(_input.StyledInput, {
  textAlign: 'center',
  paddingLeft: '0',
  paddingRight: '0'
});
StyledInputOverrideInput.displayName = "StyledInputOverrideInput";
StyledInputOverrideInput.displayName = 'StyledInputOverrideInput';